import { Button, Dropdown } from "components/ui";
import { PLACEMENT, AI_IMAGE_EDIT_ENABLED } from "components/ui/utils/constant";
import { BsStars } from "react-icons/bs";
import { TbPencilStar } from "react-icons/tb";
import { getFileTypeImageVideo } from "utils/fileType";
import { useImageChat } from "contexts/ImageChatContext";
import PlusBadge from "components/shared/PlusBadge";

const MagicEditButton = ({
    asset,
    onAssetEdit = undefined,
    size = "sm",
    placement = PLACEMENT.TOP_END,
    isPostPreview = false,
    portal = true,
}) => {

    const { openImageChat, hasEditModel, closeImageChat } = useImageChat();

    const type = getFileTypeImageVideo(asset?.video?.url || asset?.image?.url);

    const handleOnOpenImageChat = () => {
        openImageChat([asset?.image?.url], {
            isSelectable: true,
            onImageSelect: (originalSrc, asset) => {
                onAssetEdit && onAssetEdit(originalSrc, "");
                closeImageChat();
            },
        });
    }

    if (type !== "image" || !AI_IMAGE_EDIT_ENABLED) {
        return <></>;
    }

    return (
        <Dropdown
            portal={portal}
            placement={placement}
            menuClass="w-auto max-w-[220px] max-h-[300px] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
            renderTitle={
                <Button
                    shape="round"
                    variant="ai"
                    size={size}
                    className="!rounded-xl"
                    icon={<TbPencilStar />}
                />
            }
        >
            {hasEditModel ? (
                <Dropdown.Item className="!p-0">
                    <div
                        onClick={(e) => { handleOnOpenImageChat(); e.stopPropagation(); }}
                        className="w-full h-ful flex items-center gap-2 cursor-pointer py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-600"
                    >
                        <div className="flex gap-2 items-center">
                            <BsStars className='h-4 md:text-xl text-primary-500' />
                            <span className="font-bold text-xs">AI Image Editor</span>
                        </div>
                    </div>
                </Dropdown.Item>
            ) : (
                <Dropdown.Item className="!p-0">
                    <div className="w-full h-ful flex items-center gap-4 py-2 px-4 hover:bg-gray-100 dark:hover:bg-gray-600">
                        <div className="flex gap-2 items-center cursor-not-allowed opacity-40">
                            <BsStars className='h-4 md:text-xl text-primary-500' />
                            <span className="font-bold text-xs">AI Image Editor</span>
                        </div>
                        <PlusBadge
                            feature={`AI Image Editor`}
                            placement='right'
                            wrapperClassName="!-mr-1 !ml-2"
                        />
                    </div>
                </Dropdown.Item>
            )}
        </Dropdown>
    )
}

export default MagicEditButton;
